import ApiService from './api';

const AssetService = {
  getBilloBordje: async function (id) {
    const query = `${process.env.VUE_APP_ROOT_API_ENV}/partners/selectbillobordje?username=${id}`;
    try {
      const response = await ApiService.get(query);
      if(response.status && response.data){
        console.log('-- get billo bordje ok --');
        return response.data;
      }
      console.warn('!! get billo bordje invalid');
      return false;
    } catch (error) {
      console.warn('!! get billo bordje error ', error);
      return false;
    }
  },
  getLogos: async function() {
    const query = `${process.env.VUE_APP_ROOT_API_ENV}/partners/selectlogos`;
    try {
      const response = await ApiService.get(query);
      if(response.status && response.data){
        console.log('-- get logos ok --');
        return response.data;
      }
      console.warn('!! get logos invalid');
      return false;
    } catch (error) {
      console.warn('!! get logos error ', error);
      return false;
    }
  }
};

export default AssetService;
